<style>
  @media screen and (width < 1200) {
    .sectionContainer {
      font-size: 1rem;
    }
  }
</style>

<div>
  <div [hidden]="viewingSearchDetails || selectedTransaction">
    <!--
    <div style="width:400px;">
      <app-cardtype-chart chartType="pie" [merchantId]="storage.getCurrentOrganization()?.id" ></app-cardtype-chart>
    </div>
    -->

    <div [hidden]="!allowMetrics">
      <!-- width-comfortable allows these to grow only to a certain point, at which they remain fixed so that they don't take up so much height-->
      <div
        class="containerMargins"
        style="
          display: flex;
          flex-direction: row;
          align-items: start;
          gap: 20px;
        "
      >
        <!-- <app-transactions-chart chartType="bar" [merchantId]="storage.getSelectedLocation() ? storage.getSelectedLocation()?.id : ''" ></app-transactions-chart>
        <app-revenue-chart chartType="line" [merchantId]="storage.getSelectedLocation() ? storage.getSelectedLocation()?.id : ''" ></app-revenue-chart> -->

        <!-- <div style="flex:1; height:225px; font-size:.9em; overflow: hidden;">
        <div class="sectionContainer paddedContent containerMargins" style="overflow: hidden;">

          <div style="display:flex; margin-bottom:15px; align-items: center;">
            <div class="header" style="flex: 0 0 auto; padding-right: 15px; font-size:1.1em; font-weight: bold;">
              Monthly transactions
            </div>
            <div style="flex:1;">
              <a [routerLink]="['/transactions']">see all transactions</a>
            </div>
          </div>
          <app-monthly-transaction-summary></app-monthly-transaction-summary>

        </div>
      </div> -->
      </div>
    </div>

    @if (allowMyTransactions) {
      <div
        style="
          display: flex;
          flex-direction: row;
          align-content: space-between;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <div style="flex: 1">
          <div class="sectionContainer paddedContent containerMargins">
            <div style="display: flex" class="defaultMargins">
              <div style="flex: 1">
                <h1 class="cpo-table-title">Recent Transactions</h1>
              </div>
            </div>
            <app-filterable-table
              #transactionsTable
              [tableView]="transactionsTableView"
              (selectedRecord)="handleTransactionSelected($event)"
            ></app-filterable-table>
          </div>
        </div>
      </div>
    }

    <!--
  <app-filterable-table #transactionsSummaryTable [tableView]="summaryTableView" (selectedRecord)="handleSummaryRecordSelected($event)" ></app-filterable-table>
  -->

    <div style="margin-bottom: 20px">
      <div
        style="
          display: flex;
          flex-direction: row;
          align-content: space-between;
          justify-content: space-between;
        "
      >
        <div style="flex: 1">
          <!-- <div class="sectionContainer paddedContent containerMargins">
            <div style="display: flex" class="defaultMargins">
              <div style="margin-right: 8px">
                <div
                  [class]="'iconButton noHover'"
                  title="Recent chargebacks"
                  aria-label="Recent chargebacks"
                >
                  <app-icon [type]="'Chargeback'" [color]="'#ffffff'" />
                </div>
              </div>
              <div style="flex: 1">
                <h2 style="margin: 0px; padding: 0px">Recent chargebacks</h2>
              </div>
            </div>

            <app-chargebacks-summary></app-chargebacks-summary>
          </div> -->

          <!-- <div class="sectionContainer paddedContent containerMargins" [hidden]="!allowMyBusinesses || numberOfMyBusinesses <= 1">
        <h2>My Businesses</h2>

        <app-filterable-table [tableView]="businessesTableView" [options]="businessTableOptions"
        (selectedRecord)="handleBusinessSelected($event)" (refreshed)="handleBusinessesRefreshed($event)"></app-filterable-table>

      </div> -->

          @if (allowMyMIDs) {
            <div
              class="sectionContainer paddedContent containerMargins"
              [hidden]="this.numberOfMyMids == 0"
            >
              <div style="display: flex" class="defaultMargins">
                <div style="flex: 1">
                  <h1 class="cpo-table-title">Locations</h1>
                </div>
              </div>
              <app-filterable-table
                #merchantTable
                [tableView]="merchantsTableView"
                (selectedRecord)="handleMerchantSelected($event)"
                (refreshed)="handleMerchantsRefreshed($event)"
              ></app-filterable-table>
            </div>
          }
          <!-- <div class="sectionContainer paddedContent containerMargins">
            <app-merchant-statements-list
              [header]="'Statements'"
              [userId]="storage.getCurrentUser().id"
            ></app-merchant-statements-list>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="selectedTransaction == undefined">
    <div class="containerMargins">
      <app-transaction-details
        [transaction]="selectedTransaction"
      ></app-transaction-details>
    </div>

    <div>
      <input
        type="button"
        value="Close"
        class="button_primary button_var_2"
        (click)="selectedTransaction = undefined"
      />
    </div>
  </div>
</div>
